module.exports = __webpack_public_path__ + "img/图片8.a533a4da.png";